import React, {useEffect, useState} from 'react';
import Addresspage from './Addresspage';
import Attachmentpage from './Attachmentpage';
import Emergencydetails from './Emergencydetails';
import moment from 'moment';
import { CONSULTANT_BACKGROUND } from "../../constants/ApiEndpoints";
import { Card, Button, Form, message, Result, Spin } from 'antd';
import {fetchStart, fetchSuccess} from "../../appRedux/actions/Common";
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { compressImage } from '../../util/CommonUtils/CompressImage';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';

function Index() {
  const dispatch = useDispatch()
  const [form] = Form.useForm();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const emailfromUrl = searchParams.get('key');
  var tokenfromUrl = searchParams.get('token');
  var onboarding_bgc_tokenFromUrl = searchParams.get('onboarding_bgc_token');
  const [currentPage, setCurrentPage] = useState(Infinity); // we can use 1 on the place of the Infinity
  const [formDataBackground, setFormDataBackground] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState({status: true, errorMessage: null});
  const [availableFormFields, setAvailableFormFields] = useState([]);
  const [allowedPages, setAllowedPages] = useState([]);

  const nextPage = () => {
        form.validateFields()
        .then( async values => {
              if(values && values.bachelors_degree && values.bachelors_degree.fileList && values.bachelors_degree.fileList.length === 0 ){
                message.error("Please Upload Bachelor's Degree")
                return
              }
              if(values && values.bachelors_last_marksheet && values.bachelors_last_marksheet.fileList && values.bachelors_last_marksheet.fileList.length === 0 ){
                message.error("Please Upload Last Year Mark Sheet")
                return
              }
              if(values && values.transcript && values.transcript.fileList && values.transcript.fileList.length === 0 ){
                message.error("Please Upload Transcript")
                return
              }
              if(values && values.us_equivalent && values.us_equivalent.fileList && values.us_equivalent.fileList.length === 0 ){
                message.error("Please Upload US Equivalent")
                return
              }
              if(values && values.ifMaster && values.ifMaster === 'yes' && values.masters_degree && values.masters_degree.fileList && values.masters_degree.fileList.length === 0 ){
                message.error("Please Upload Masters Degree")
                return
              }
              if(values && values.ifMaster && values.ifMaster === 'yes' && values.masters_last_marksheet && values.masters_last_marksheet.fileList && values.masters_last_marksheet.fileList.length === 0 ){
                message.error("Please Upload Masters Last Marksheet")
                return
              }
              ////
            const compressFiles = async (field, fileList) => {
              return Promise.all(fileList.map(async file => {
                if (file.originFileObj.size <= 1048576) {  // this is the size of 1MB in bytes
                  return file;
                }
              //  console.log(`Original ${field} File Size:`, file.originFileObj.size);
               const compressedFile = await compressImage(file.originFileObj);
                //  console.log(`Compressed ${field} File Size:`, compressedFile.size);
                return { ...file, originFileObj: compressedFile };
              }));
            };

            const fileFields = [ 'bachelors_degree', 'bachelors_last_marksheet', 'transcript','us_equivalent',
              'masters_degree','masters_last_marksheet' ];
            for (const field of fileFields) {
              if (values[field] && values[field].fileList) {
                values[field].fileList = await compressFiles(field, values[field].fileList);
              }
            }
          ////
            localStorage.setItem('formDataBackground', JSON.stringify({ ...formDataBackground, ...values }));
            // setCurrentPage(currentPage + 1);
            if (allowedPages && currentPage !== undefined) {
              const sortedPages = [...allowedPages].sort((a, b) => a - b);
              const nextPageToShow = sortedPages.find(page => page > currentPage);

              if (nextPageToShow !== undefined) {
                setCurrentPage(nextPageToShow);
              } else {
                console.log('No next page found');
              }
            }
        })
        .catch(errorInfo => {
            message.error("Upload required Details ")
            console.error("Validation failed:", errorInfo);
        });
    };

    const currentDomain = window.location.hostname;
      var endpoint = '';
      if (currentDomain === 'dev.stell.one') {
          endpoint = "https://dev-backend.stell.one/api/consultants/bgc-details/";
      } 
      else if (currentDomain === 'stell.one') {
          endpoint = "https://prod-backend.stell.one/api/consultants/bgc-details/";
      }
      else if(currentDomain === 'staging.stell.one'){
          endpoint = "https://backend.stell.one/api/consultants/bgc-details/";
      }
      else if (currentDomain === 'localhost' || currentDomain === '127.0.0.1' || currentDomain === '0.0.0.0') {
          endpoint = "http://localhost:8000/api/consultants/bgc-details/";
          // endpoint = "https://backend.stell.one/api/consultants/bgc-details/";

      }else{
          endpoint = "https://backend.stell.one/api/consultants/bgc-details/";
      }
  
    useEffect(() => {
        const storedData = localStorage.getItem('formDataBackground');
        if (storedData) {
          const formData = JSON.parse(storedData);
            delete formData.bachelors_degree;
            delete formData.bachelors_last_marksheet;
            delete formData.transcript;
            delete formData.us_equivalent;
            delete formData.masters_degree;
            delete formData.masters_last_marksheet;
            delete formData.i9_form;
            delete formData.ssn_back_copy;
            delete formData.ssn_front_copy;

          setFormDataBackground(formData);
          localStorage.setItem('formDataBackground', JSON.stringify({ ...formData}));
        }
        if(emailfromUrl && endpoint){
          setPageLoading({status: true, errorMessage: null})
          axios.get(`${endpoint}?key=${emailfromUrl}&onboarding_bgc_token=${onboarding_bgc_tokenFromUrl}` )
          .then((response) => {
            if(response?.data?.fields){
              setAvailableFormFields(response?.data?.fields)
              setPageLoading({status: false, errorMessage: null})
            }else{
              setPageLoading({status: false, errorMessage: {error:'Oops! Something went wrong'}})
            }
          })
          .catch(({response}) => {
              setPageLoading({status:false, errorMessage: response?.data})
              message.error('Error fetching the form!');
          });
        }
      }, []);

  const prevPage = () => {
    localStorage.setItem('formDataBackground', JSON.stringify({ ...formDataBackground}));
    if (allowedPages && currentPage !== undefined) {
      const sortedPages = [...allowedPages].sort((a, b) => a - b);
      const nextPageToShow = sortedPages.find(page => page < currentPage);
      if (nextPageToShow !== undefined) {
        setCurrentPage(nextPageToShow);
      } else {
        console.log('No next page found');
      }
    }
    // setCurrentPage(currentPage - 1);
  };
  
  
      const handleSubmit = ()=>{
        form.validateFields()
        .then( async values => {
          if(values && values.i9_form && values.i9_form.fileList && values.i9_form.fileList.length === 0 ){
            message.error("Please Upload I-9 Form")
            return
          }
          if(values && values.ssn_front_copy && values.ssn_front_copy.fileList && values.ssn_front_copy.fileList.length === 0 ){
            message.error("Please Upload SSN Front Copy")
            return
          }
          // if(values && values.ssn_back_copy && values.ssn_back_copy.fileList && values.ssn_back_copy.fileList.length === 0 ){
          //   message.error("Please Upload SSN Back Copy")
          //   return
          // }
        ////
          const compressFiles = async (field, fileList) => {
            return Promise.all(fileList.map(async file => {
              if (file.originFileObj.size <= 1048576) { // this is the size of 1MB in bytes
                return file;
              }
              const compressedFile = await compressImage(file.originFileObj);
              return { ...file, originFileObj: compressedFile };
            }));
          };

          const fileFields = ['i9_form', 'ssn_front_copy', 'ssn_back_copy'];
          for (const field of fileFields) {
            if (values[field] && values[field].fileList) {
              values[field].fileList = await compressFiles(field, values[field].fileList);
            }
          }
          ////

        const dataToSend = prepareFormData(formDataBackground);
        dataToSend.append('onboarding_bgc_token',onboarding_bgc_tokenFromUrl)
        // if(formDataBackground && formDataBackground.ifMaster && formDataBackground.ifMaster === 'no'){
        //   if ('masters_degree' in formDataBackground) {
        //     delete dataToSend.masters_degree;
        //   }
        //   if ('masters_last_marksheet' in formDataBackground) {
        //       delete dataToSend.masters_last_marksheet;
        //     }
        //   }
        
        dispatch(fetchStart());
        setLoading(true)
        axios.post(endpoint, dataToSend, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            setLoading(false)
            dispatch(fetchSuccess());
            message.success('Form Submitted Successfully!');
            localStorage.removeItem('formDataBackground')
            setFormDataBackground({})
            form.resetFields()
            // setCurrentPage(1)
            // setTimeout(()=>{
            //   window.location.reload()
            // },400)
            setPageLoading({ status: false, errorMessage: null, successMessage: { message: 'Form submitted successfully!' } })
        })
        .catch((error) => {
            setLoading(false)
            message.error('Error Submitting the form!');
            console.log('error', error);
        });
      })
      .catch(errorInfo => {
          setLoading(false)
          message.error("Upload required Details")
          console.error("Validation failed:", errorInfo);
      });
      }

    const prepareFormData = (data) => {
          const formData = new FormData();
          formData.append('email', data.email || atob(emailfromUrl) || null);
          formData.append("token", data.token || atob(tokenfromUrl) || null);
          if(availableFormFields?.includes('addresses') && data?.address){
            const formattedAddresses = data.address.map(addr => ({
              ...addr,
              move_in: dayjs(addr.move_in).format('YYYY-MM-DD'),
              move_out: dayjs(addr.move_out).format('YYYY-MM-DD'),
              country:'USA'
            }));
            formData.append('addresses', JSON.stringify(formattedAddresses));
          }
          if(availableFormFields?.includes('emergency_contacts') && data?.emergency_contact_1){
            formData.append('emergency_contacts', JSON.stringify([
              data.emergency_contact_1,
              data.emergency_contact_2
            ]));
          }

          // Appending files to formData
        var fileKeys = []
        if(data && data.ifMaster && data.ifMaster === 'no'){
          fileKeys = [
            'bachelors_degree', 'bachelors_last_marksheet', 'transcript',
            'us_equivalent', 
            'i9_form', 'ssn_front_copy', 'ssn_back_copy'
          ];
        }
        else{
          fileKeys = [
            'bachelors_degree', 'bachelors_last_marksheet', 'transcript',
            'us_equivalent', 'masters_degree', 'masters_last_marksheet',
            'i9_form', 'ssn_front_copy', 'ssn_back_copy'
          ];
        }
          for (const key of fileKeys) {
            if (data[key] && data[key].file) {
              formData.append(key, data[key].fileList[0].originFileObj);
            }
          }
          return formData;
    };

  const pageFieldMap = {
    1: ['addresses'],
    2: ['education_details'],
    3: ['i9_form', 'ssn_copy', 'emergency_contacts'],
  };

  const validateFormPage = (pageNumber, availableFormFields) => {
    const fields = pageFieldMap[pageNumber] || [];
    return fields.some(field => availableFormFields.includes(field));
  };

  const getValidPages = (availableFormFields) => {
    return Object.keys(pageFieldMap)
      .map(Number)
      .filter(pageNumber => validateFormPage(pageNumber, availableFormFields));
  };

  useEffect(() => {
    if (availableFormFields && availableFormFields.length > 0) {
      const validPages = getValidPages(availableFormFields);
      if (validPages.length > 0) {
        setCurrentPage(validPages[0]);
        setAllowedPages(validPages);
      } else {
        setPageLoading({ status: false, errorMessage: { error: 'Oops! Something went wrong' } });
      }
    }
  }, [availableFormFields]);

  let timeoutId = null;
  const throttledHandleSubmit = () => {
    if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            handleSubmit();
            timeoutId = null;
        }, 500);
  };

  if (!pageLoading.status && !pageLoading.errorMessage && pageLoading.successMessage) {
    return (
      <div style={{ display: 'flex', height: '80vh', alignItems: 'center', justifyContent: 'center' }}>
        <Result
          status="success"
          // title="Welcome to American Chase"
          subTitle={pageLoading?.successMessage?.message || 'Form submitted successfully!'}
        />
      </div>
    );
  }

  if (pageLoading.status && !pageLoading.errorMessage) {
    return (
      <div style={{ display: 'flex', height: '80vh', alignItems: 'center', justifyContent: 'center' }}>
        <Result
          icon={<Spin size="large" />}
          title="Welcome to American Chase"
          subTitle="Loading... please wait"
        />
      </div>
    );
  }

  if (!pageLoading.status && pageLoading.errorMessage) {
    return (
      <div style={{ display: 'flex', height: '80vh', alignItems: 'center', justifyContent: 'center' }}>
        <Result
          status="error"
          title="Oops! Something went wrong"
          subTitle={
            typeof pageLoading.errorMessage?.error === 'string'
              ? <>
                <div>
                  Invalid URL - The URL you requested is not valid or has expired.
                </div>
                <div>
                  If you continue to experience issues, contact our support team or your hiring coordinator for assistance.
                </div>
              </>
              : 'An unexpected error occurred. Please try again later.'
          }
        />
      </div>
    );
  }
  
return (<>
  {pageLoading && pageLoading.status === true && !pageLoading.errorMessage ? 
    'Wellcome to American Chase. Loading.. please wait' 
    :
    pageLoading.status === false && pageLoading.errorMessage ? 
      pageLoading.errorMessage.error && typeof pageLoading.errorMessage.error === 'string' ?  
        pageLoading.errorMessage.error 
        :
        "Something went wrong"
    :
    <div style={styles.div}>
    <Card style={styles.card} bodyStyle={styles.cardBody}>
      <div style={{width:"100%",textAlign:"center",fontWeight:"bold",fontSize:"20px"}}>Details Required For Background Check</div>
            <div style={{width:"100%",textAlign:"center", fontSize:"15px"}}>List of Addresses you lived in the last 10 years starting from the current address to the previous addresses.</div>
        {currentPage === 1 && (
          <Addresspage 
            formDataBackground={formDataBackground} 
            setFormDataBackground={setFormDataBackground} 
            form={form} 
            availableFormFields={availableFormFields}
          />
        )}
        {currentPage === 2 && (
          <Attachmentpage 
            formDataBackground={formDataBackground} 
            setFormDataBackground={setFormDataBackground} 
            form={form} 
            availableFormFields={availableFormFields}
          />
        )}
        {currentPage === 3 && (
          <Emergencydetails 
            formDataBackground={formDataBackground} 
            setFormDataBackground={setFormDataBackground} 
            form={form}
            availableFormFields={availableFormFields}
          />
        )}
        {/* {currentPage > 1 && <Button onClick={prevPage}>Back</Button>}
        {currentPage < 3 ? <Button onClick={nextPage}>Next</Button>: <Button disabled={loading} type="button" onClick={handleSubmit}>Submit</Button>}  */}
        {currentPage > Math.min(...allowedPages) && (
          <Button onClick={prevPage}>Back</Button>
        )}
        {currentPage < Math.max(...allowedPages) && (
          <Button onClick={nextPage}>Next</Button>
        )}
        {currentPage === Math.max(...allowedPages) && (
          <Button disabled={loading} type="primary" onClick={throttledHandleSubmit}>
            Submit
          </Button>
        )}
      </Card>

    </div>
  }
  </>
)
}

export default Index

const styles = {
  card: {
    // margin:"2% 10% 0% 10%"
    margin:"2% 2% 0% 2%"
  },
  div : {
      overflow:'auto',
      height:'100vh' 
  }
};


// import React, {useEffect, useState} from 'react';
// import Addresspage from './Addresspage';
// import Attachmentpage from './Attachmentpage';
// import Emergencydetails from './Emergencydetails';
// import moment from 'moment';
// import { CONSULTANT_BACKGROUND } from "../../constants/ApiEndpoints";
// import { Card, Button, Form, message } from 'antd';
// import {fetchStart, fetchSuccess} from "../../appRedux/actions/Common";
// import { useDispatch } from 'react-redux';
// import axios from 'axios';
// import { compressImage } from '../../util/CommonUtils/CompressImage';
// import dayjs from 'dayjs';
// import { useLocation } from 'react-router-dom';

// function Index() {
//   const dispatch = useDispatch()
//   const [currentPage, setCurrentPage] = useState(1);
//   const [formDataBackground, setFormDataBackground] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [form] = Form.useForm();

//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   var onboarding_bgc_tokenFromUrl = searchParams.get('onboarding_bgc_token');

//   const nextPage = () => {
//         form.validateFields()
//         .then( async values => {
//               if(values && values.bachelors_degree && values.bachelors_degree.fileList && values.bachelors_degree.fileList.length === 0 ){
//                 message.error("Please Upload Bachelor's Degree")
//                 return
//               }
//               if(values && values.bachelors_last_marksheet && values.bachelors_last_marksheet.fileList && values.bachelors_last_marksheet.fileList.length === 0 ){
//                 message.error("Please Upload Last Year Mark Sheet")
//                 return
//               }
//               if(values && values.transcript && values.transcript.fileList && values.transcript.fileList.length === 0 ){
//                 message.error("Please Upload Transcript")
//                 return
//               }
//               if(values && values.us_equivalent && values.us_equivalent.fileList && values.us_equivalent.fileList.length === 0 ){
//                 message.error("Please Upload US Equivalent")
//                 return
//               }
//               if(values && values.ifMaster && values.ifMaster === 'yes' && values.masters_degree && values.masters_degree.fileList && values.masters_degree.fileList.length === 0 ){
//                 message.error("Please Upload Masters Degree")
//                 return
//               }
//               if(values && values.ifMaster && values.ifMaster === 'yes' && values.masters_last_marksheet && values.masters_last_marksheet.fileList && values.masters_last_marksheet.fileList.length === 0 ){
//                 message.error("Please Upload Masters Last Marksheet")
//                 return
//               }
//               ////
//             const compressFiles = async (field, fileList) => {
//               return Promise.all(fileList.map(async file => {
//                 if (file.originFileObj.size <= 1048576) {  // this is the size of 1MB in bytes
//                   return file;
//                 }
//               //  console.log(`Original ${field} File Size:`, file.originFileObj.size);
//                const compressedFile = await compressImage(file.originFileObj);
//                 //  console.log(`Compressed ${field} File Size:`, compressedFile.size);
//                 return { ...file, originFileObj: compressedFile };
//               }));
//             };

//             const fileFields = [ 'bachelors_degree', 'bachelors_last_marksheet', 'transcript','us_equivalent',
//               'masters_degree','masters_last_marksheet' ];
//             for (const field of fileFields) {
//               if (values[field] && values[field].fileList) {
//                 values[field].fileList = await compressFiles(field, values[field].fileList);
//               }
//             }
//           ////
//             localStorage.setItem('formDataBackground', JSON.stringify({ ...formDataBackground, ...values }));
//             setCurrentPage(currentPage + 1);
//         })
//         .catch(errorInfo => {
//             message.error("Upload required Details ")
//             console.error("Validation failed:", errorInfo);
//         });
//     };
  
//     useEffect(() => {
//         const storedData = localStorage.getItem('formDataBackground');
//         if (storedData) {
//           const formData = JSON.parse(storedData);
//             delete formData.bachelors_degree;
//             delete formData.bachelors_last_marksheet;
//             delete formData.transcript;
//             delete formData.us_equivalent;
//             delete formData.masters_degree;
//             delete formData.masters_last_marksheet;
//             delete formData.i9_form;
//             delete formData.ssn_back_copy;
//             delete formData.ssn_front_copy;

//           setFormDataBackground(formData);
//           localStorage.setItem('formDataBackground', JSON.stringify({ ...formData}));
//         }
//       }, []);

//   const prevPage = () => {
//     localStorage.setItem('formDataBackground', JSON.stringify({ ...formDataBackground}));
//     setCurrentPage(currentPage - 1);
//   };
  
  
//       const handleSubmit = ()=>{
//         form.validateFields()
//         .then( async values => {
//           if(values && values.i9_form && values.i9_form.fileList && values.i9_form.fileList.length === 0 ){
//             message.error("Please Upload I-9 Form")
//             return
//           }
//           if(values && values.ssn_front_copy && values.ssn_front_copy.fileList && values.ssn_front_copy.fileList.length === 0 ){
//             message.error("Please Upload SSN Front Copy")
//             return
//           }
//           if(values && values.ssn_back_copy && values.ssn_back_copy.fileList && values.ssn_back_copy.fileList.length === 0 ){
//             message.error("Please Upload SSN Back Copy")
//             return
//           }
//         ////
//           const compressFiles = async (field, fileList) => {
//             return Promise.all(fileList.map(async file => {
//               if (file.originFileObj.size <= 1048576) { // this is the size of 1MB in bytes
//                 return file;
//               }
//               const compressedFile = await compressImage(file.originFileObj);
//               return { ...file, originFileObj: compressedFile };
//             }));
//           };

//           const fileFields = ['i9_form', 'ssn_front_copy', 'ssn_back_copy'];
//           for (const field of fileFields) {
//             if (values[field] && values[field].fileList) {
//               values[field].fileList = await compressFiles(field, values[field].fileList);
//             }
//           }
//           ////

//         const dataToSend = prepareFormData(formDataBackground);
//         dataToSend.append('onboarding_bgc_token',onboarding_bgc_tokenFromUrl)
//         // if(formDataBackground && formDataBackground.ifMaster && formDataBackground.ifMaster === 'no'){
//         //   if ('masters_degree' in formDataBackground) {
//         //     delete dataToSend.masters_degree;
//         //   }
//         //   if ('masters_last_marksheet' in formDataBackground) {
//         //       delete dataToSend.masters_last_marksheet;
//         //     }
//         //   }
//         const currentDomain = window.location.hostname;
//         var endpoint = '';
//         if (currentDomain === 'dev.stell.one') {
//             endpoint = "https://dev-backend.stell.one/api/consultants/bgc-details/";
//         } 
//         else if (currentDomain === 'stell.one') {
//             endpoint = "https://prod-backend.stell.one/api/consultants/bgc-details/";
//         }
//         else if(currentDomain === 'staging.stell.one'){
//             endpoint = "https://backend.stell.one/api/consultants/bgc-details/";
//         }
//         else if (currentDomain === 'localhost' || currentDomain === '127.0.0.1' || currentDomain === '0.0.0.0') {
//             endpoint = "http://localhost:8000/api/consultants/bgc-details/";
//             // endpoint = "https://backend.stell.one/api/consultants/bgc-details/";

//         }else{
//             endpoint = "https://backend.stell.one/api/consultants/bgc-details/";
//         }
//         dispatch(fetchStart());
//         setLoading(true)
//         axios.post(endpoint, dataToSend, {
//             headers: {
//                 'Content-Type': 'multipart/form-data'
//             }
//         })
//         .then((response) => {
//             setLoading(false)
//             dispatch(fetchSuccess());
//             message.success('Form Submitted Successfully!');
//             localStorage.removeItem('formDataBackground')
//             setFormDataBackground({})
//             form.resetFields()
//             setCurrentPage(1)
//             setTimeout(()=>{
//               window.location.reload()
//             },200)
//         })
//         .catch((error) => {
//             setLoading(false)
//             message.error('Error Submitting the form!');
//             console.log('error', error);
//         });
//       })
//       .catch(errorInfo => {
//           setLoading(false)
//           console.error("Validation failed:", errorInfo);
//       });
//       }

//     const prepareFormData = (data) => {
//           const formData = new FormData();
//           formData.append('email', data.email);
//           formData.append("token", data.token);
//           const formattedAddresses = data.address.map(addr => ({
//             ...addr,
//             move_in: dayjs(addr.move_in).format('YYYY-MM-DD'),
//             move_out: dayjs(addr.move_out).format('YYYY-MM-DD'),
//             country:'USA'
//           }));
//           formData.append('addresses', JSON.stringify(formattedAddresses));
//           formData.append('emergency_contacts', JSON.stringify([
//             data.emergency_contact_1,
//             data.emergency_contact_2
//           ]));

//           // Appending files to formData
//         var fileKeys = []
//         if(data && data.ifMaster && data.ifMaster === 'no'){
//           fileKeys = [
//             'bachelors_degree', 'bachelors_last_marksheet', 'transcript',
//             'us_equivalent', 
//             'i9_form', 'ssn_front_copy', 'ssn_back_copy'
//           ];
//         }
//         else{
//           fileKeys = [
//             'bachelors_degree', 'bachelors_last_marksheet', 'transcript',
//             'us_equivalent', 'masters_degree', 'masters_last_marksheet',
//             'i9_form', 'ssn_front_copy', 'ssn_back_copy'
//           ];
//         }
//           for (const key of fileKeys) {
//             if (data[key] && data[key].file) {
//               formData.append(key, data[key].fileList[0].originFileObj);
//             }
//           }
//           return formData;
//     };


// return (
//   <div style={styles.div}>
//    <Card style={styles.card} bodyStyle={styles.cardBody}>
//       {currentPage === 1 && (
//           <Addresspage formDataBackground={formDataBackground} setFormDataBackground={setFormDataBackground} form={form} />
//       )}
//       {currentPage === 2 && (
//           <Attachmentpage formDataBackground={formDataBackground} setFormDataBackground={setFormDataBackground} form={form} />
//       )}
//       {currentPage === 3 && (
//           <Emergencydetails formDataBackground={formDataBackground} setFormDataBackground={setFormDataBackground} form={form}/>
//       )}
//       {currentPage > 1 && <Button onClick={prevPage}>Back</Button>}
//       {currentPage < 3 ? <Button onClick={nextPage}>Next</Button>: <Button disabled={loading} type="button" onClick={handleSubmit}>Submit</Button>} 
//     </Card>
//    </div>
// )
// }

// export default Index

// const styles = {
//   card: {
//     // margin:"2% 10% 0% 10%"
//     margin:"2% 2% 0% 2%"
//   },
//   div : {
//       overflow:'auto',
//       height:'100vh' 
//   }
// };